import React from 'react';
import './aboutDetails.css';
import { useResources, useComponentResources } from '../../store/resourcesProvider';

const AboutDetails: React.FC = () => {
    const resources = useResources();
    const pageRes = useComponentResources('AboutDetails', [
        'AboutDetails.PageTitle','AboutDetails.Intro','AboutDetails.ProfessionalSummary.Title','AboutDetails.ProfessionalSummary.Content',
        'AboutDetails.Expertise.Heading','AboutDetails.Expertise.1.Title','AboutDetails.Expertise.1.Items','AboutDetails.Expertise.2.Title','AboutDetails.Expertise.2.Items',
        'AboutDetails.Education.Heading','AboutDetails.Education.Items','AboutDetails.Additional.Heading','AboutDetails.Additional.Items','AboutDetails.Quote'
    ]);

    const splitLines = (text?: string) => {
        if (!text) return [];
        return text.split(/\r?\n/).map(s => s.trim()).filter(s => s.length > 0);
    };

    return (
        <div className="content-shell about-details">
            <h1>{pageRes['AboutDetails.PageTitle'] ?? resources.get('AboutDetails.PageTitle','אודות — אפרת בורוכובסקי-קוריס')}</h1>

            <div className="intro">
                <p>{pageRes['AboutDetails.Intro'] ?? resources.get('AboutDetails.Intro','להלן ריכוז מידע על אפרת בורוכובסקי-קוריס, המשלבת קריירה ארוכת שנים כזמרת ומורה לפיתוח קול עם מומחיות בפסיכותרפיה וטיפול בקול.')}</p>
            </div>

            <section className="section">
                <h2>{pageRes['AboutDetails.ProfessionalSummary.Title'] ?? resources.get('AboutDetails.ProfessionalSummary.Title','תקציר מקצועי (עבור דף הבית)')}</h2>
                <p>{pageRes['AboutDetails.ProfessionalSummary.Content'] ?? resources.get('AboutDetails.ProfessionalSummary.Content','אפרת בורוכובסקי-קוריס היא מטפלת בקול (Vocal Therapist), פסיכותרפיסטית דינמית ומורה מנוסה לפיתוח קול. היא מציעה גישה ייחודית המחברת בין עבודה טכנית-קולית לבין תהליכי עומק רגשיים, מתוך תפיסה שהקול הוא "חלון לנשמה" ואמצעי מרכזי לביטוי עצמי ותקשורת בין-אישית.')}</p>
            </section>

            <section className="section">
                <h2>{pageRes['AboutDetails.Expertise.Heading'] ?? resources.get('AboutDetails.Expertise.Heading','תחומי מומחיות')}</h2>

                <div className="expertise">
                    <h3>{pageRes['AboutDetails.Expertise.1.Title'] ?? resources.get('AboutDetails.Expertise.1.Title','פיתוח קול והוראה')}</h3>
                    <ul>
                        {splitLines(pageRes['AboutDetails.Expertise.1.Items'] ?? resources.get('AboutDetails.Expertise.1.Items','ניסיון: שנים רבות של הוראת פיתוח קול ותיאטרון במסגרות שונות, קונסרבטוריונים ובאופן פרטי.\nהגישה: עבודה על הקול ככלי ביטוי אמנותי ואישי. השיעורים משלבים טכניקה קולית, עבודה על נשימה, יציבה ונוכחות בימתית.\nקהל יעד: זמרים, שחקנים, ואנשים המבקשים לגלות ולשחרר את קולם הטבעי.')).map((it, idx) => <li key={idx}>{it}</li>)}
                    </ul>

                    <h3>{pageRes['AboutDetails.Expertise.2.Title'] ?? resources.get('AboutDetails.Expertise.2.Title','פסיכותרפיה וטיפול בקול (Vocal Psychotherapy)')}</h3>
                    <ul>
                        {splitLines(pageRes['AboutDetails.Expertise.2.Items'] ?? resources.get('AboutDetails.Expertise.2.Items','גישה טיפולית: פסיכותרפיה דינמית בשילוב אמנויות הבמה ותנועה.\nהקול ככלי טיפולי: שימוש בקול, בשירה ובאלתור קולי כאמצעי לאבחון, התערבות וריפוי. הטיפול מתמקד בחיבור בין הקול הפיזי לקול הפנימי.\nהתמחויות רגשיות: ליווי במצבי חרדה, דיכאון, קשיים בדימוי עצמי, ויסות רגשי ופוסט-טראומה.')).map((it, idx) => <li key={idx}>{it}</li>)}
                    </ul>
                </div>
            </section>

            <section className="section">
                <h2>{pageRes['AboutDetails.Education.Heading'] ?? resources.get('AboutDetails.Education.Heading','השכלה והסמכות')}</h2>
                <ul>
                    {splitLines(pageRes['AboutDetails.Education.Items'] ?? resources.get('AboutDetails.Education.Items','MA בטיפול במוזיקה: אוניברסיטת בר-אילן (כולל תזה מחקרית בנושא "הקול של המטפל ומשמעותו לעבודה הטיפולית").\nלימודי תעודה בתרפיה במוזיקה וקול: בשילוב תנועה, סמינר לוינסקי.\nBA בתיאטרון: אוניברסיטת תל אביב.\nהכשרה בפסיכותרפיה: בוגרת לימודי פסיכותרפיה בגישה דינמית.\nחברות באיגודים: מדריכה בכירה באגודת יה"ת (האגודה לטיפול באמצעות אמנויות בישראל).')).map((it, idx) => <li key={idx}>{it}</li>)}
                </ul>
            </section>

            <section className="section">
                <h2>{pageRes['AboutDetails.Additional.Heading'] ?? resources.get('AboutDetails.Additional.Heading','פעילות מקצועית נוספת')}</h2>
                <ul>
                    {splitLines(pageRes['AboutDetails.Additional.Items'] ?? resources.get('AboutDetails.Additional.Items','הנחיה והרצאות: מעבירה סדנאות וקורסים בנושא שימוש קולי מודע והקול כאמצעי תקשורת.\nכתיבה ומחקר: פרסמה מאמרים בנושא טיפול מקוון באמנויות וחוקרת את המודעות של מטפלים לקולם האישי.\nמיקומים: עובדת בקליניקה פרטית בתל אביב (אזור כיכר מילאנו / רב צעיר) ומקיימת מפגשים מקוונים (Online).')).map((it, idx) => <li key={idx}>{it}</li>)}
                </ul>
            </section>

            <aside className="quote">
                <blockquote>
                    {pageRes['AboutDetails.Quote'] ?? resources.get('AboutDetails.Quote','"הקול הוא כמו עיניים – חלון לנשמה. אני מזמינה אותך למסע עמוק לגילוי הקול שלך, הפנימי וזה שיוצא החוצה, עד לשחרורו המלא לאוויר העולם."')}
                </blockquote>
            </aside>
        </div>
    );
};

export default AboutDetails;
